module.exports = __webpack_public_path__ + "static/media/3.c62589ac.svg";